import React from 'react';
import StepSection from '../../../../Elements/StepSection';
import HeadedCard from '../../../../Elements/HeadedCard';
import LabeledValues from '../../../../Elements/LabeledValues';
import NumberedList from '../../../../Elements/NumberedList';
import ShowNameComponent from '../../../../Elements/ShowNameComponent';
import CurrencyService from '../../../../Services/CurrencyService';
import ClientInvoiceFormOptionsArray from '../../../../Enums/ClientInvoiceFormOptionsArray';
import selectHelper from '../../../../Helpers/selectHelper';
import {
  fillTemplate,
  getHowOneInvoiceWorks,
  getJobsOnInvoiceText,
  getMonthIso,
  getPaymentTermsAndLayoutSummary,
} from '../../../../Helpers/invoiceAutomationSetupPageHelper';
import InvoiceAutomationProjectsOnInvoice from './InvoiceAutomationProjectsOnInvoice';

// Step 2 of the setup page: how the one invoice is made, and its settings read back on its card, the reference and
// the comment filled in for this month as a draft of this month gets them, the projects on it, the payment terms and
// the layout in its foot. Those who may change the setup get Edit on the card (onEdit), and the button that changes
// the other projects on the invoice (onChangeProjects).
export default function InvoiceAutomationInvoiceStep({
  setup = null,
  clientName = '',
  contactName = null,
  canEdit = false,
  onEdit = () => {},
  onChangeProjects = () => {},
}) {
  const thisMonth = getMonthIso(new Date());
  const values = [
    {
      label: 'Invoice name',
      value: fillTemplate(setup.ReferenceTemplate, thisMonth),
      note: setup.ReferenceTemplate ? `This month's, from "${setup.ReferenceTemplate}"` : null,
      isWide: true,
    },
    {
      label: 'Jobs on this invoice',
      value: getJobsOnInvoiceText(setup),
      note: 'From the first month on, except jobs a person took off a draft',
      isWide: true,
    },
    { label: 'Bill to', value: contactName, note: clientName, isWide: true },
    { label: 'Purchase order #', value: setup.Ponumber },
    {
      label: 'Currency',
      value: setup.CurrencyId ? (
        <ShowNameComponent
          id={setup.CurrencyId}
          serviceFunction={CurrencyService.GetCurrencyNameById}
        />
      ) : null,
    },
    {
      label: 'Invoice form',
      value: selectHelper.getOptionLabel(ClientInvoiceFormOptionsArray, setup.DefaultReportName),
    },
    { label: 'Invoice comments', value: fillTemplate(setup.CommentTemplate, thisMonth), isWide: true },
  ];

  return (
    <StepSection
      number={2}
      title='Invoice'
      lead='Which jobs Bravo takes, and the invoice it makes of them each month.'
      isLast={true}
    >
      <div className='iauto-invoice-grid'>
        <div className='iauto-how'>
          <h4 className='iauto-how-title'>How it works</h4>
          <NumberedList items={getHowOneInvoiceWorks(setup.JobMonthRule, setup.RunSchedule)} />
        </div>
        <HeadedCard
          kicker='The only invoice'
          title='Monthly invoice'
          actions={canEdit ? [{ label: 'Edit', iconName: 'fa-solid fa-pen', onClick: onEdit }] : []}
          foot={<span>{getPaymentTermsAndLayoutSummary(setup)}</span>}
        >
          <LabeledValues values={values} />
          <InvoiceAutomationProjectsOnInvoice
            setup={setup}
            canEdit={canEdit}
            onChange={onChangeProjects}
          />
        </HeadedCard>
      </div>
    </StepSection>
  );
}
